import { Numeric } from "./numeric.js";
/**
 * {@link https://drafts.csswg.org/css-values/#dimensions}
 *
 * @public
 */
export class Dimension extends Numeric {
    _unit;
    constructor(value, unit, type) {
        super(value, type);
        this._unit = unit;
    }
    get unit() {
        return this._unit;
    }
    hasUnit(unit) {
        return this._unit === unit;
    }
    equals(value) {
        return (value instanceof Dimension &&
            super.equals(value) &&
            value._unit === this._unit);
    }
    toJSON() {
        return { ...super.toJSON(), unit: this._unit };
    }
}
/**
 * @public
 */
(function (Dimension) {
    function isDimension(value) {
        return value instanceof Dimension;
    }
    Dimension.isDimension = isDimension;
})(Dimension || (Dimension = {}));
//# sourceMappingURL=dimension.js.map